import type { ReactNode } from "react"
import styles from "./Chip.module.css"

type Props = {
    children: ReactNode
    className?: string
    onClick?: () => void
    hoverColor?: boolean
}

export default function Chip({children, className, onClick, hoverColor} : Props) {
  return (
    <div onClick={onClick} className={`${styles.chip} ${hoverColor ? styles.hover : ""} ${className}`}>
        {children}
    </div>
  )
}
